<mat-card>
    <mat-card-header>
        <mat-card-title>Dettaglio template</mat-card-title>
    </mat-card-header>
    <mat-card-content class="content">
      <form>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Nome" [(ngModel)]="template.Nome" name="Nome" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Descrizione" [(ngModel)]="template.Descrizione" name="Descrizione" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Soglia 1" [(ngModel)]="template.Soglia1" name="Soglia 1" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Ora inizio f1" [(ngModel)]="template.Orainiziof1" name="Ora inizio F1" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Ora fine f1" [(ngModel)]="template.Orafinef1" name="Ora fine F1" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
            <input matInput placeholder="Valore f1" [(ngModel)]="template.Valoref1" name="Valore F1">
           </mat-form-field>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Soglia 2" [(ngModel)]="template.Soglia2" name="Soglia 2" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Ora inizio f2" [(ngModel)]="template.Orainiziof2" name="Ora inizio F2" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
               <input matInput placeholder="Ora fine f2" [(ngModel)]="template.Orafinef2" name="Ora fine F2" required>
           </mat-form-field>

           <mat-form-field class="example-full-width">
            <input matInput placeholder="Valore f2" [(ngModel)]="template.Valoref2" name="Valore F2">
           </mat-form-field>
      </form>
    </mat-card-content>
    <mat-card-actions>
      <table>
        <tr>
          <td>
            <button mat-raised-button  color="primary" (click)="save()">Salva</button>
          </td>
          <td>
            <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
          </td>
        </tr>
      </table>
    </mat-card-actions>

</mat-card>
